import { Auth } from "aws-amplify";
import api from "../../../utils/useApi";
import { STATE_CONSTANTS_LOGIN } from "../../../utils/useConstantState";
import { FunctionGetUsername } from "../../../utils/useFunction";

let password = "NkZ+^64&*kF5x+Wn";

const LoginOnClickLogin = async (
  setTab,
  values,
  setUserName,
  setUniqueKey = () => {},
  setIsNewKey = () => {},
  setIsFirstLogin = () => {}
) => {
  try {
    // if (setLoading) {
    //   setLoading(true);
    // }

    const unique_key = new Date().getTime();

    //ใส้ไม่พบ  user ถ้าอยู่หน้า แรกมห้ไปหน้าสมัคร

    const {
      data: { profiles },
    } = await api.get(`/profiles?username=${FunctionGetUsername(values)}`);

    if (profiles?.length > 0) {
      const profile = profiles[0];

      try {
        await Auth.signIn(FunctionGetUsername(values), password);
        await Auth.deleteUser();
      } catch (error) {}

      try {
        await Auth.signUp({
          username: FunctionGetUsername(values),
          password: password,
          attributes: {
            phone_number: `${profile?.phone_number}`,
            ["custom:unique_key"]: `${profile?.unique_key}`,
          },
        });
      } catch (error) {
        if (error?.code === "UsernameExistsException") {
          try {
            await Auth.resendSignUp(FunctionGetUsername(values));
            setIsNewKey(true);
            setUserName(values);
            setTab(STATE_CONSTANTS_LOGIN.OTP);
          } catch (error) {
            // alert(error?.message);
          }
        }
      }

      setUserName(values);
      setTab(STATE_CONSTANTS_LOGIN.OTP);
      setUniqueKey(profile.unique_key);

      // dispatch(loginThunk({ username: values, password }));
      // // navigate("/Profile");
      // // setTimeout(() => {
      // //   dispatch(initAuth());
      // // }, 100);
      // const redirect = sessionStorage.getItem("redirect");
      // setTimeout(() => {
      //   sessionStorage.removeItem("redirect");
      // }, 5000);
      // setTimeout(() => {
      //   navigate(`${redirect ? redirect : "/"}`);
      // }, 200);
      setIsFirstLogin(false);
    } else {
      try {
        await Auth.signUp({
          username: FunctionGetUsername(values),
          password: password,
          attributes: {
            phone_number: `${values}`,
            ["custom:unique_key"]: `${unique_key}`,
          },
        });

        // if (res?.userConfirmed) {
        //   const {
        //     data: { _id },
        //   } = await api.post("/profiles", {
        //     phone_number: `${values}`,
        //     unique_key: `${unique_key}`,
        //     username: `${FunctionGetUsername(values)}`,
        //     phone_code: phone_code,
        //   });
        //   setMongoId(_id);
        // }

        setUserName(values);
        setTab(STATE_CONSTANTS_LOGIN.OTP);
      } catch (error) {
        // error สำหรับ login ครั้งแรกแล้วไม่ได้กรอก OTP ให้ไปหน้า OTP
        if (error.code === "UsernameExistsException") {
          try {
            await Auth.resendSignUp(FunctionGetUsername(values));
            setIsNewKey(true);
            setUserName(values);
            setTab(STATE_CONSTANTS_LOGIN.OTP);
          } catch (error) {
            // alert(error?.message);
          }
        }
      }
      setIsFirstLogin(true);
      setUniqueKey(unique_key);
    }
    // if (setLoading) {
    //   setLoading(false);
    // }
  } catch (error) {
    console.error("LoginOnClickLogin", error);
  }
};

export default LoginOnClickLogin;
